var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhoneIco(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100px",
    height: "100px",
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon/phone") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Admin",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Login-In-Help-",
    transform: "translate(-590.000000, -405.000000)",
    fill: "#279CF7",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon-phone",
    transform: "translate(590.000000, 405.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80.75,72.06 C84.295,67.06 71.95,55.13 67.75,58.015 L64.205,61.165 C64.205,61.165 55.8,65.365 44.765,55.125 C34.125,44.235 38.725,35.7 38.725,35.7 L41.875,32.155 C44.63,27.955 32.42,15.615 27.82,19.155 L19.415,28.61 C17.71,30.71 19.02,34.91 19.02,35.305 C20.0613151,38.6890958 21.3790869,41.9818531 22.96,45.15 C30.0303923,58.9125581 41.2352355,70.1139042 55,77.18 C58.4733183,78.8997307 62.1298513,80.22145 65.9,81.12 C66.295,81.12 69.84,82.17 71.55,80.465 L80.75,72.06 Z",
    id: "Path_5268"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100,50 L100,50 C99.9627386,22.4348655 77.596449,0.113880698 50.0312956,0.132499751 C22.4661422,0.151142112 0.130045622,22.5023403 0.130045622,50.0675 C0.130045622,77.6326597 22.4661422,99.9838579 50.0312956,100.0025 C77.596449,100.021119 99.9627386,77.7001345 100,50.135 L100,50 Z M50,3.33499893 C62.3771407,3.33234681 74.2481076,8.24797175 83.0000679,16.9999321 C91.7520283,25.7518924 96.6676532,37.6228593 96.6650011,50 L96.6650011,50 L96.6650011,50 C96.6650011,75.7723679 75.7723679,96.665 50,96.665 C24.2276321,96.665 3.335,75.7723679 3.335,50 C3.335,24.2276321 24.2276321,3.33499893 50,3.33499893 Z",
    id: "Path_5269"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIco);
export default __webpack_public_path__ + "static/media/phone_ico.c21da1ccaa0c274b95d213055f80d49c.svg";
export { ForwardRef as ReactComponent };